import Ajax from "./Ajax"
const GetBhk = async() => {
    const response = await Ajax({
        url: `/product/bhk?limit=false`,
        token: true
    })
    return response.data.result
}
export default GetBhk